import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/firestore';

var firebaseConfig = {
	apiKey: 'AIzaSyB1VYcuxmUSvGTyevdmb4L8qdogZ_MiQ1E',
	authDomain: 'lyricster-pro.firebaseapp.com',
	projectId: 'lyricster-pro',
	storageBucket: 'lyricster-pro.appspot.com',
	messagingSenderId: '1011857796579',
	appId: '1:1011857796579:web:05751ed9ddb6ee991cc4d6',
	measurementId: 'G-2PNFL7YWL4',
};

firebase.initializeApp(firebaseConfig);

let firestore = firebase.firestore();
let auth = firebase.auth();
let storage = firebase.storage();

//Collections

let usersCollection = firestore.collection("users");
let articlesCollection = firestore.collection('articles');
let challengesCollection = firestore.collection('challenges');
let adsCollection = firestore.collection('ads');
let newsCollection = firestore.collection('news');
let postsCollection = firestore.collection('posts');
let musicRoomsCollection = firestore.collection('music_rooms');
let featuredUsersCollection = firestore.collection('featured_users');
let chatsCollection = firestore.collection('chats');
let connectRequestsCollection = firestore.collection('connect_requests');
let groupsCollection = firestore.collection('groups');
let groupRequestsCollection = firestore.collection('group_requests');
let notificationsCollection = firestore.collection('notifications');
let verificationCollection = firestore.collection('verification_requests');

export {
	firebase,
	firestore,
	auth,
	storage,
	usersCollection,
	articlesCollection,
	challengesCollection,
	adsCollection,
	newsCollection,
	postsCollection,
	featuredUsersCollection,
	musicRoomsCollection,
	chatsCollection,
	connectRequestsCollection,
	groupsCollection,
	groupRequestsCollection,
	notificationsCollection,
	verificationCollection,
};